import React, { useState } from 'react';
import Header from './components/Header'
import Form from './components/Form'
import Resume from './components/Resume'
import Result from './components/Result'
import Spinner from './components/Spinner'
import styled from '@emotion/styled'

const Container = styled.div`
  max-width:600px;
  margin: 0 auto;
`;

const ContainerForm = styled.div`
  background-color:#fff;
  padding:3rem;
`;

function App() {

  const [loading, isLoading] = useState(false);

  const [resume, saveResume] = useState({
    quotation: 0,
    data: {
      brand: '',
      year: '',
      plan: '',
    }
  });

  const { quotation, data } = resume;


  return (
    <Container>
      <Header
        title="Cotizador de seguros"
      />
      <ContainerForm>
        <Form
          saveResume={saveResume}
          isLoading={isLoading}
        />

        {(loading) ? <Spinner /> : null}

        <Resume
          data={data}
        />


        {(!loading)
          ?
          <Result
            quotation={quotation}
          />
          : null}

      </ContainerForm>
    </Container>
  );
}

export default App;
